import React from 'react';
import { Grid, Row, Col } from '../utils/bootstrap';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Colors from '../Colors';
import MainImage from '../components/MainImage';

class ProductInfo extends React.Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Asset-based Lending | Corporate Loans | Premium Capital Partners</title>
          <meta name="description" content="Premium Capital Partners offers Asset-based Lending and Corporate Transaction Loans that meet your unique business financing needs." />
        </Helmet>
        <MainImage img="/business.jpg">
          <h1>Asset-based lending</h1>
          <div />
          <h2>Business Financing</h2>
          <div />
        </MainImage>
        <Grid>
          <Row>
            <Col xs={12}>
              <p>
                Premium Capital Partners offers secured business loans that unlock the value of
                your business assets, whether that's to release funding for growth or provide the
                financial support for critical contract financing or for your intended corporate
                transaction.
              </p>
              <Row className="lined-row">
                <Col lg={4}>
                  <h4>Corporate Transaction Loans</h4>
                </Col>
                <Col lg={8}>
                  <p>
                    Premium Capital Partners pioneering Corporate Transaction Loans offer
                    flexible
                    financing for corporate transactions, informed by our team's extensive
                    experience
                    working in dynamic international finance markets.
                  </p>
                  <p>
                    We're keen to offer financial products that help bridge a significant gap in the
                    Malaysian business landscape. We offer corporate transaction financing for
                    key events such as management buyouts and pre-IPO investments. Our Corporate
                    Transaction Loans operate on a model which provides a unique market
                    opportunity for financing managed corporate risk.
                  </p>
                </Col>
              </Row>
              <Row className="lined-row">
                <Col lg={4}>
                  <h4>
                    How does asset-based financing work?
                  </h4>
                </Col>
                <Col lg={8}>
                  <p>
                    Our Asset-based Lending provides an opportunity to take advantage of a
                    traditional
                    secured business loan, with financing solutions guided by the extensive
                    industry
                    experience of Premium Capital Partners' team of globally qualified financial
                    professionals.
                  </p>
                  <p>
                    This financing model is particularly vital for the small and medium
                    enterprises(SMEs) that form the foundation of the regional economy, offering
                    essential business financing for SMEs that provides an important catalyst
                    for
                    growth.
                  </p>
                </Col>
              </Row>
              <br /><br /><br />
            </Col>
          </Row>
        </Grid>
        <MainImage
          img="/about.jpg"
          containerStyle={{ justifyContent: 'center', height: 'auto' }}
          overlayStyle={{ backgroundColor: 'rgba(0,0,0,0.85)' }}
          innerDivStyle={{
            width: '100%',
            position: 'relative',
            top: 0,
            left: 0,
            transform: 'none',
            paddingLeft: 0,
            paddingRight: 0
          }}
        >
          <Grid>
            <Row>
              <Col xs={12}>
                <h5 style={{ marginTop: '0.5em', textAlign: 'left' }}>Why choose Premium Capital
                  Partners?</h5>
                <p>
                  As a pioneer of innovative financial solutions for the Malaysian market, Premium
                  Capital Partners are able to offer flexible business financing products that
                  respond to the needs of each unique customer. We don't present off-the-shelf
                  solutions like some traditional lenders, but instead cater our financial offering
                  based on your particular needs, guided by our own substantial industry experience.
                </p>
                <p>
                  The market in Malaysia offers a significant opportunity to provide effective
                  financial solutions. However, barriers presented by risk-averse institutional
                  investors and resultant challenges for wider market liquidity make accessing this
                  financing difficult for some businesses. With our personalised and individualised
                  approach, Premium Capital Partners are in a position to assess financing for
                  businesses in situations where conventional institutional lenders may be reluctant
                  to do so.
                </p>
              </Col>
            </Row>
          </Grid>
        </MainImage>
        <div style={{ backgroundColor: Colors.grey, width: '100%' }}>
          <Grid>
            <Row style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
              <Col xs={12} sm={9}>
                <h4 style={{
                  color: 'white',
                  fontWeight: 'normal',
                  fontSize: '1.2em',
                  marginTop: 0
                }}>
                  Contact Premium Capital Partners to find out more about our Asset-based Lending
                  and
                  Corporate Transaction Loans, and explore how we can help you access effective
                  financing to
                  meet your unique business needs.
                </h4>
              </Col>
              <Col xs={12} sm={3} className="contact-button">
                <Link to="/contact-us">
                  <button style={{ borderColor: Colors.lightBlue, color: Colors.lightBlue }}>
                    Contact Us
                  </button>
                </Link>
              </Col>
            </Row>
          </Grid>
        </div>
      </div>
    );
  }
}

export default ProductInfo;



// WEBPACK FOOTER //
// ./src/screens/Business.js